import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import PasswordReset from '../PasswordReset';
import PasswordFindWeb from './web';
import PasswordFindMob from './mob';

const PasswordFind = () => {
  const [searchParams] = useSearchParams();
  const resetToken = useMemo(() => searchParams.get('token')?.trim() ?? '', [searchParams]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (resetToken) {
    return <PasswordReset token={resetToken} />;
  }

  return isMobile ? <PasswordFindMob /> : <PasswordFindWeb />;
};

export default PasswordFind;

